module.exports = __webpack_public_path__ + "img/16_23.748e4b87.png";